import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import RiskEstimator from "@/components/RiskEstimator";
import Founder from "@/components/Founder";
import Insights from "@/components/Insights";
import WhyCompliance from "@/components/WhyCompliance";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AdminLogin from "@/pages/AdminLogin";
import AdminInsights from "@/pages/AdminInsights";

function HomePage() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-[#faf9f6] text-[#1b2a4e] font-body min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <RiskEstimator />
        <Founder />
        <Insights />
        <WhyCompliance />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/insights" element={<AdminInsights />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
